import axios from '@axios'

export const state = {
  credits: [],
}

export const getters = {
  allAutochecks: (state) => state.credits,
}

export const mutations = {
  GET_AUTOCHECKS: (state, resp) => {
    if (!resp) return null
    state.credits = resp.data.credits
  },
  ADD_AUTOCHECK: (state, autocheck) => {
    state.credits.unshift(autocheck)
  },
}

export const actions = {
  async getCredit({ commit }) {
    await axios
      .get('/api/credits')
      .then((resp) => {
        if (resp.status === 200) commit('GET_AUTOCHECKS', resp)
      })
      .catch(() => {
        commit('GET_AUTOCHECKS', null)
      })
  },
  async addCredit({ commit }, form) {
    return axios.post('/api/credits', form)
  },
}
